import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'shalala';

import { useStore } from '../../../../../store';
import SearchInput from '../../../../../facturotopia/search-input/SearchInput';
import CalendarDateRangePicker from '../../../../../facturotopia/calendar-date-range-picker/CalendarDateRangePicker.jsx';

class ComprobantesSearch extends Component {
  state = {};

  constructor(props) {
    super(props);

    const {
      filters: { from: asFrom, to: asTo },
    } = this.props.list;

    const from = !!asFrom ? moment(asFrom) : moment().subtract(7, 'days');
    const to = !!asTo ? moment(asTo) : moment();

    this.state = {
      from: from.toDate(),
      to: to.toDate(),
    };
  }

  handleOnKeywordChange = (keyword) => {
    const { filters } = this.props.list;

    this.props.listActions.paginate({
      ...filters,
      search: keyword,
    });
  };

  handleOnSearchClear = () => {
    this.handleOnKeywordChange('');
  };

  handleOnDateChange = (date) => {
    const { filters } = this.props.list;
    const from = moment(date[0]);
    const to = moment(date[1]);

    this.props.listActions.paginate({
      ...filters,
      page: 1,
      from: from.format('YYYY-MM-DD'),
      to: to.format('yyyy-MM-DD'),
    });

    this.setState({
      from: date[0],
      to: date[1],
    });
  };

  render() {
    const { from, to } = this.state;
    const {
      filters: { search },
    } = this.props.list;

    return (
      <div className="d-flex flex-column flex-sm-row">
        <div className="pr-2 pb-2">
          <CalendarDateRangePicker
            value={[from, to]}
            onDateChange={this.handleOnDateChange}
          />
        </div>
        <div className="flex-fill search-container">
          <SearchInput
            onKeywordChange={this.handleOnKeywordChange}
            onClear={this.handleOnSearchClear}
            value={search}
          />
        </div>
      </div>
    );
  }
}

const mapState = (store) => {
  return { list: store.external.receptores.comprobantes.list };
};

const mapActions = (actions) => {
  return { listActions: actions.external.receptores.comprobantes.list };
};

export default connect(useStore, mapState, mapActions)(ComprobantesSearch);
